export const appendSpecificitySelector = (rule, seed = '', repeatSelector = 3) => {
    const selector = ':not(#\\20)';
    const prefix = Array(repeatSelector + 1).join(selector);
    if (rule.includes(prefix)) {
        return rule;
    }
    const seedSelector = `.${seed}`;
    if (seed) {
        if (rule.search(seedSelector) === -1) {
            return rule;
        }
        return rule.split(seedSelector).join(`${prefix}${seedSelector}`);
    }
    return `${prefix}${rule}`;
};
export const increaseSpecificity = (repeatSelector) => {
    // similar to https://www.npmjs.com/package/jss-increase-specificity
    // https://github.com/iamstarkov/jss-increase-specificity/blob/master/index.js
    const onProcessRule = (rule) => {
        const parent = rule.options.parent;
        if (rule.type !== 'style' ||
            (parent && 'type' in parent && parent.type === 'keyframes') ||
            !rule.selectorText) {
            return;
        }
        rule.selectorText = appendSpecificitySelector(rule.selectorText, '', repeatSelector);
    };
    return { onProcessRule };
};
//# sourceMappingURL=increaseSpecificity.js.map